module.exports = __webpack_public_path__ + "img/floor2_3.01e29120.jpg";